module.exports = __webpack_public_path__ + "media/zuopin2.0fd6a8c5.mp4";